import React from "react";
import { Table } from "react-bootstrap";
// import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

const PHQ9Interpretation = () => {
  return (
    <div className={styles["interpretation"]}>
      <div className={styles["interpretation__title"]}>
        PHQ-9 Interpretation:
      </div>

      <div className={styles["interpretation__text"]}>
        Total scores of 5, 10, 15, and 20 represent cutpoints for mild,
        moderate, moderately severe and severe depression, respectively.
      </div>
      <br />
      <div className={styles["interpretation__text"]}>
        <b>Note:</b> Question 9 is a single screening question on suicide risk.
        A patient who answers yes to question 9 needs further assessment for
        suicide risk by an individual who is competent to assess this risk.
      </div>
      <div className={styles["interpretation__score"]}>
        <ul>
          <li>
            Score <b>0-4: Non-minimal</b>
          </li>
          <li>
            Score <b>5-9: Mild </b>
          </li>
          <li>
            Score <b>10-14: Moderate</b>
          </li>
          <li>
            Score{" "}
            <b>
              15-19: <span className={"red"}>Moderately Severe</span>
            </b>
          </li>
          <li>
            Score{" "}
            <b>
              20-27: <span className={"red"}>Severe</span>
            </b>
          </li>
        </ul>
      </div>

      <hr />

      <Table className={styles["interpretation__table"]} size="sm">
        <thead>
          <tr>
            <th
              className={styles["interpretation__table-title-th"]}
              colSpan={5}
            >
              Provisional Diagnosis and Proposed Treatment Actions
            </th>
          </tr>
          <tr className={styles["interpretation__table-second-tr"]}>
            <th></th>
            <th>PHQ-9 Score</th>
            <th>Depression Severity</th>
            <th>Proposed Treatment Actions</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>0-4</td>
            <td>None-minimal</td>
            <td>None</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>5-9</td>
            <td>Mild</td>
            <td>Watchful waiting; repeat PHQ-9 at follow-up</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>10-14</td>
            <td>Moderate</td>
            <td>
              Treatment plan, considering counseling, follow-up and/or
              parmacotherapy
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>15-19</td>
            <td>Moderately Severe</td>
            <td>Active treatment with pharmacotherapy and/or psychotherapy</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>20-27</td>
            <td>Severe</td>
            <td className={styles[""]}>
              Immediate initiation of pharmacotherapy and, if severe impairment
              or poor response to therapy, expedited referral to a mental health
              specialist for psychotherapy and/or collaborative management
            </td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <hr />
      <div className={"bd-12"}>Source</div>
      <br />
      <div className={styles["interpretation__footnote"]}>
        <ul>
          <li>
            Kroenke K, Spitzer RL, Williams JB. The Patient Health
            Questionnaire-2: Validity of a Two-Item Depression Screener. Medical
            Care. 2003;41:1284-92.
          </li>
          <li>
            Kroenke K, Spitzer RL, Williams JB. The PHQ-9: validity of a brief
            depression severity measure. J Gen Intern Med. 2001;16:606-13.
          </li>
          <li>
            Kroenke K, Spitzer RL. The PHQ-9: a new depression diagnostic and
            severity measure. Psychiatr Ann. 2002;32:509-21.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PHQ9Interpretation;
